"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ReportingEmployeeDocument () {
        return ReportingEmployeeDocument;
    },
    get ReportingEmployeeReportDocument () {
        return ReportingEmployeeReportDocument;
    }
});
const _bson = require("bson");
const _zod = require("zod");
const ReportingEmployeeReportDocument = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    company_id: _zod.z.instanceof(_bson.ObjectId),
    user_id: _zod.z.instanceof(_bson.ObjectId),
    last_updated: _zod.z.date(),
    as_of: _zod.z.date(),
    primary_role: _zod.z.string(),
    state: _zod.z.object({
        custom_values: _zod.z.record(_zod.z.string(), _zod.z.unknown()).nullable()
    }),
    hash: _zod.z.string(),
    name: _zod.z.string()
});
const ReportingEmployeeDocument = _zod.z.object({
    _id: _zod.z.instanceof(_bson.ObjectId),
    name: _zod.z.string(),
    email: _zod.z.object({
        original: _zod.z.string(),
        normalized: _zod.z.string()
    }),
    company: _zod.z.object({
        _id: _zod.z.instanceof(_bson.ObjectId),
        name: _zod.z.string()
    }),
    manager: _zod.z.object({
        _id: _zod.z.instanceof(_bson.ObjectId),
        name: _zod.z.string(),
        email: _zod.z.string()
    }).nullable(),
    chain_of_command: _zod.z.array(_zod.z.object({
        _id: _zod.z.instanceof(_bson.ObjectId),
        name: _zod.z.string(),
        email: _zod.z.string()
    })),
    group: _zod.z.object({
        _id: _zod.z.instanceof(_bson.ObjectId),
        name: _zod.z.string()
    }).nullable(),
    group_administrator: _zod.z.array(_zod.z.object({
        _id: _zod.z.instanceof(_bson.ObjectId),
        name: _zod.z.string(),
        admins: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
        employees: _zod.z.array(_zod.z.instanceof(_bson.ObjectId)),
        company: _zod.z.instanceof(_bson.ObjectId),
        admin_permissions: _zod.z.object({
            "group-feedback": _zod.z.boolean(),
            "group-reviews": _zod.z.boolean(),
            "group-goals": _zod.z.boolean()
        })
    })),
    custom_values: _zod.z.record(_zod.z.string(), _zod.z.unknown()).nullable(),
    primary_role: _zod.z.string(),
    deactivated: _zod.z.object({
        state: _zod.z.boolean(),
        at: _zod.z.date().nullable(),
        by: _zod.z.instanceof(_bson.ObjectId).nullable()
    })
});
